import React from 'react';
import CategoryCard from './CategoryCard';
import { categories } from '../data/data';

const RecipeCategories = () => {
  return (
    <section className="popular-categories section">
      <div className="container">
        <h2 className="section-title">Recipe Categories</h2>
        
        <div className="categories-grid">
          {categories.map(category => (
            <CategoryCard key={category.id} category={category} />
          ))}
        </div>
      </div>
      
      <style jsx>{`
        .categories-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 2rem;
        }
        
        @media (max-width: 992px) {
          .categories-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        
        @media (max-width: 576px) {
          .categories-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </section>
  );
};

export default RecipeCategories;